import React from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import './Education.scss';
import Typography from '@mui/material/Typography';
import { educationData } from "./educationData";
import EducationBox from "../EducationBox/EducationBox";

const Education = () => {
    
    React.useEffect(() => {
        AOS.init();
        AOS.refresh();
    }, []);

    return (
        <div id="education">

            <div className="container">

                <Typography variant="h3" gutterBottom component="div" className="text-center main-heading">
                    Education
                </Typography>
                <Typography variant="h6" gutterBottom component="div" className="text-center mini-heading">
                    Stuff I am made of
                </Typography>

                <div className="education-boxes">
                    {
                        educationData.map((education, index) => (
                            <div 
                                key={index}
                                data-aos="fade-up" 
                                data-aos-delay={150*(index+1)}
                                data-aos-duration="900"
                                data-aos-easing="ease-in-out"
                            >
                                <EducationBox  education={education} />
                            </div>
                        ))
                    }
                </div>

            </div>
        </div>
    );
}

export default Education;